import { render, staticRenderFns } from "./zanneixin-list.vue?vue&type=template&id=39328d75&scoped=true&"
import script from "./zanneixin-list.vue?vue&type=script&lang=js&"
export * from "./zanneixin-list.vue?vue&type=script&lang=js&"
import style0 from "./zanneixin-list.scss?vue&type=style&index=0&id=39328d75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39328d75",
  null
  
)

export default component.exports